<template>
    <div v-if="entries.length" class="flex flex-col w-full pb-2">
        <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800">
            Client Feedback History:
        </div>
        <ul class="flex flex-col gap-1">
            <li v-for="entry in entries" :key="entry.key" class="flex gap-2 border-l-2 border-gray-300 pl-2">
                <span class="shrink-0 text-gray-500">{{ formatFeedbackDate(entry.created_at) }}</span>
                <span v-if="entry.kind === 'feedback'" class="capitalize">{{ feedbackLabel(entry.feedback) }}</span>
                <span v-else class="whitespace-pre-wrap break-all">{{ entry.notes || '--' }}</span>
                <span v-if="isFromAnotherCampaign(entry, company)" class="shrink-0 text-gray-500">({{ entry.campaign.campaign_name }})</span>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { formatFeedbackDate, isFromAnotherCampaign } from '@/utils/clientFeedback';

const props = defineProps({
    company: Object
})

// Every feedback mark, and the notes left for any client other than the current one --
// the current client's notes are listed with the company's Client Feedback Notes.
// Newest first, the way they were recorded.
const entries = computed(() => {
    const currentNoteIds = new Set((props.company.current_client_feedback_notes ?? []).map((note) => note.id))
    const feedback = (props.company.client_feedback_new ?? []).map((row) => ({ ...row, kind: 'feedback', key: `feedback-${row.id}` }))
    const notes = (props.company.client_feedback_notes_new ?? [])
        .filter((row) => !currentNoteIds.has(row.id))
        .map((row) => ({ ...row, kind: 'note', key: `note-${row.id}` }))
    return [...feedback, ...notes].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
})

function feedbackLabel(feedback) {
    return feedback ? feedback.replaceAll('_', ' ') : 'Cleared'
}
</script>
